import { FC } from "react";
import { Typography } from "antd";

const OverviewTab: FC = () => {
    return (
        <div>
            <Typography.Title level={4}>Overview</Typography.Title>
            <Typography.Text>Summary of overall analytics goes here.</Typography.Text>
        </div>
    );
};

export default OverviewTab;
